<template>
    <v-toolbar :color="toolbarColor" dense elevation="0">
        <v-icon left>mdi-file-export</v-icon>
        <v-toolbar-title>Reports</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>

<script>
export default {
    name: 'reports-toolbar',
    computed: {
        toolbarColor() {
            return '#8950FC';
        }
    }
}
</script>